import { AuthLevel, generateApiPath } from '@guiker/api-definition'

export const paths = {
  conversations: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'conversation' }),
}
